export var isOverflowed = function isOverflowed(el) {
  return (el === null || el === void 0 ? void 0 : el.scrollWidth) > (el === null || el === void 0 ? void 0 : el.offsetWidth) || (el === null || el === void 0 ? void 0 : el.scrollHeight) > (el === null || el === void 0 ? void 0 : el.offsetHeight);
};